import { BrokenImage } from '@mui/icons-material';
import { Avatar, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

const DisplayIntegrationInfo = ({ imageUrl, title, subtitle, description }) => {
  const theme = useTheme();
  return (
    <Stack>
      <Stack direction="row" spacing={4}>
        <Avatar
          src={imageUrl}
          sx={{
            width: 90,
            height: 90,
            border: `1px solid ${theme.palette.divider}`
          }}
        >
          <BrokenImage />
        </Avatar>
        <Stack justifyContent="center">
          <Typography variant="h4" color={theme.palette.grey[600]}>
            {title}
          </Typography>
          {subtitle}
        </Stack>
      </Stack>
      {description && (
        <Typography variant="body2" sx={{ pt: 1.5 }}>
          {description}
        </Typography>
      )}
    </Stack>
  );
};

DisplayIntegrationInfo.propTypes = {
  imageUrl: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.node,
  description: PropTypes.string
};

export default DisplayIntegrationInfo;
